import { CompleteUser } from '../@types'
import { Config } from '../context/config'

import { calculateAge } from './age'

interface UserProfileConfig {
  displayAge?: boolean
  maximumLengthAllowed?: number
}

export const getUserProfileFromId = (profile?: CompleteUser, patientId?: number) => {
  if (profile?.id === patientId) return profile

  return profile?.dependants?.find(dependent => dependent.id === patientId)
}

export const getUserProfileFromEmrId = (profile?: CompleteUser, emrId?: string) => {
  if (profile?.emrId === emrId) return profile

  return profile?.dependants?.find(dependent => dependent.emrId === emrId)
}

export const getPatientFullName = ({
  config,
  user,
}: {
  config?: UserProfileConfig
  user: Pick<CompleteUser, 'firstName' | 'lastName'>
}) => {
  const patientName = `${user.firstName} ${user.lastName}`

  return config?.maximumLengthAllowed && patientName.length > config.maximumLengthAllowed
    ? `${user.firstName.charAt(0).toUpperCase()}. ${user.lastName}`
    : patientName
}

export const getUserProfileText = ({
  config,
  user,
}: {
  config?: UserProfileConfig
  user?: Pick<CompleteUser, 'firstName' | 'lastName' | 'dateOfBirth'>
}) => {
  if (!user) return ''

  return [getPatientFullName({ config, user }), config?.displayAge && calculateAge(user.dateOfBirth)]
    .filter(Boolean)
    .join(', ')
}

export const getAllEligibleFamilyProfilesIds = (profile?: CompleteUser) => {
  if (!profile) return []

  return [profile.id, ...(profile.dependants?.map(dependant => dependant.id) ?? [])]
}

export const canPatientAddDependents = ({ config, profile }: { config?: Config; profile?: CompleteUser }) => {
  if (!config?.partnerConfig.familyProfilesEnabled || !profile) return false

  const age = calculateAge(profile.dateOfBirth)

  if (age === null) return false

  return age >= config.minAgeRequiredToAddDependants
}
